import produce from 'immer';
import { registerReducer } from '../../../StateSetup/RootReducer';

const { BFF_URL, GBCORE_CLIENT_NAME, GBCORE_CLIENT_VERSION } = window.__ENV__;

// Action names
const ACTION_NAME_PREFIX = 'action/GetMemberSupplemental';
export const REQUEST_ACTION_NAME = `${ACTION_NAME_PREFIX}/request`;
export const RESPONSE_ACTION_NAME = `${ACTION_NAME_PREFIX}/response`;
export const ERROR_ACTION_NAME = `${ACTION_NAME_PREFIX}/error`;

/**
 * Gets member supplemental information for a member.
 * @param {object} logger
 */
export const GetMemberSupplemental = () => {
    return async (dispatch, getState, { logger }) => {
        // step 1: Request Action
        dispatch({ type: REQUEST_ACTION_NAME });

        const { jwt, sessionCorrelationId, language } = getState().Authentication;
        const transactionId = logger.generateGuid();

        logger.info(`${ACTION_NAME_PREFIX}: Fetching member data.`, { correlation: { transactionId } });

        // step 2: await Web service call
        const getMemberSupplementalQuery = await fetch(`${BFF_URL}/api/v2`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'gb-authorization': jwt,
                'mli-session-correlation-id': sessionCorrelationId,
                'mli-correlation-id': transactionId,
                'mli-channel': 'web',
                'gb-client-name': GBCORE_CLIENT_NAME,
                'gb-client-version': GBCORE_CLIENT_VERSION,
                'Accept-Language': language,
            },
            body: JSON.stringify({
                operationName: 'GetMemberSupplementalQuery',
                variable: {},
                query: `
                    query GetMemberSupplementalQuery {
                        member {
                            coverageAppliedDate(page: 1, recordsPerPage: 500)
                        }
                    }
                `,
            }),
        });

        const getMemberSupplementalQueryResponse = await getMemberSupplementalQuery.json();

        if (getMemberSupplementalQueryResponse.errors) {
            const { message, code } = getMemberSupplementalQueryResponse.errors[0];
            logger.critical(
                `${ACTION_NAME_PREFIX}: Failure when fetching member data. Code: ${code} Reason: ${message}`,
                { correlation: { transactionId } }
            );
            return dispatch({
                type: ERROR_ACTION_NAME,
                code,
                message,
            });
        }
        return dispatch({
            type: RESPONSE_ACTION_NAME,
            data: getMemberSupplementalQueryResponse.data.member,
            success: true,
        });
    };
};

export const requestReducer = produce((state) => {
    state.MemberData.isLoadingSupplementalMemberData = true;
});

export const responseReducer = produce((state, action) => {
    state.MemberData.isLoadingSupplementalMemberData = false;
    state.MemberData.member = {
        ...state.MemberData.member,
        coverageAppliedDate: action.data.coverageAppliedDate,
    };
});

/**
 * Fired off when the request encounters an error. An error thrown by this part of the code is considered a critical failure.
 * @param {object} state
 * @param {object} action
 */
export const errorReducer = produce((state, action) => {
    state.MemberData.isLoadingSupplementalMemberData = false;
    state.Errors.initialLoad.hasError = true;
    state.Errors.initialLoad.code = action.code;
    state.Errors.initialLoad.message = action.message;
});

registerReducer(REQUEST_ACTION_NAME, requestReducer);
registerReducer(RESPONSE_ACTION_NAME, responseReducer);
registerReducer(ERROR_ACTION_NAME, errorReducer);
